import { Route, Routes, Navigate } from 'react-router-dom'
import { lazy } from 'react'
import { Toaster } from 'react-hot-toast'
import ProtectedRoutes from './components/layouts/protected_routes'
import AuthBootstrap from './components/features/auth_bootstrap/auth_bootstrap'
import withSuspense from './hocs/withSuspense'
import LocalStorageProvider from './hocs/local_storage_provider'
import Checkout from './components/screens/ecommerce/checkout'

// Pos
const PosLayout = lazy(() => import('./components/layouts/pos_layout'))
const Splash = lazy(() => import('./components/screens/pos/splash'))
const Login = lazy(() => import('./components/screens/pos/login'))
const Unauthorized = lazy(() => import('./components/screens/unauthorized'))
const Categories = lazy(() => import('./components/screens/pos/categories'))
const Products = lazy(() => import('./components/screens/pos/products'))
const Orders = lazy(() => import('./components/screens/pos/orders'))
const Tables = lazy(() => import('./components/screens/pos/tables'))
const Settings = lazy(() => import('./components/screens/pos/settings'))
const Reports = lazy(() => import('./components/screens/pos/reports'))
const Users = lazy(() => import('./components/screens/pos/users'))

// Ecommerce
const EcommercerLayout = lazy(() => import('./components/layouts/ecommerce_layout'))
const ProductsMenu = lazy(() => import('./components/screens/ecommerce/products'))
const Success = lazy(() => import('./components/screens/ecommerce/success'))

// Kiosk
const KioskLayout = lazy(() => import('./components/layouts/kiosk_layout'))
const KioskLanding = lazy(() => import('./components/screens/kiosk/landing'))
const KioskProducts = lazy(() => import('./components/screens/kiosk/products'))
const KioskCheckout = lazy(() => import('./components/screens/kiosk/checkout'))
const KioskSuccess = lazy(() => import('./components/screens/kiosk/success'))

// W/Suspense
const CategoriesWithSuspense = withSuspense(Categories)
const ProductsWithSuspense = withSuspense(Products)
const SettingsWithSuspense = withSuspense(Settings)
const OrdersWithSuspense = withSuspense(Orders)
const TablesWithSuspense = withSuspense(Tables)
const ReportsWithSuspense = withSuspense(Reports)
const UsersWithSuspense = withSuspense(Users)

const EcommerceLayoutWithSuspense = withSuspense(EcommercerLayout)
const ProductsMenuWithSuspense = withSuspense(ProductsMenu)
const SuccessWithSuspense = withSuspense(Success)

const KioskLayoutWithSuspense = withSuspense(KioskLayout)
const KioskLandingWithSuspense = withSuspense(KioskLanding)
const KioskProductsWithSuspense = withSuspense(KioskProducts)
const KioskCheckoutWithSuspense = withSuspense(KioskCheckout)
const KioskSuccessWithSuspense = withSuspense(KioskSuccess)

function App() {
    return <>
        <AuthBootstrap />
        <Toaster position="top-center" />
        <Routes>

            <Route element={<LocalStorageProvider />}>
                {/* Ecommerce */}
                <Route path="/" element={<Navigate to="/products" replace />} />
                <Route element={<EcommerceLayoutWithSuspense />}>
                    <Route path="/products" element={<ProductsMenuWithSuspense />} />
                </Route>
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/success" element={<SuccessWithSuspense />} />
                {/* Kiosk */}
                <Route path="/kiosk" element={<KioskLandingWithSuspense />} />
                <Route element={<KioskLayoutWithSuspense />}>
                    <Route path="/kiosk/products" element={<KioskProductsWithSuspense />} />
                    <Route path="/kiosk/checkout" element={<KioskCheckoutWithSuspense />} />
                </Route>
                <Route path="/kiosk/success" element={<KioskSuccessWithSuspense />} />
            </Route>

            {/* POS */}
            <Route path="/pos" element={<Splash />} />
            <Route path="pos/login" element={<Login />} />
            <Route element={<PosLayout />}>
                <Route element={<ProtectedRoutes allowedRoles={['admin', 'staff']} />}>
                    <Route path="pos/categories" element={<CategoriesWithSuspense />} />
                    <Route path="pos/products/:slug" element={<ProductsWithSuspense />} />
                    <Route path="pos/orders" element={<OrdersWithSuspense />} />
                    <Route path="pos/tables" element={<TablesWithSuspense />} />
                    <Route path="pos/reports" element={<ReportsWithSuspense />} />
                </Route>
                <Route element={<ProtectedRoutes allowedRoles={['admin', 'produccion']} />}>
                    <Route path="pos/settings" element={<SettingsWithSuspense />} />
                    <Route path="pos/settings/users" element={<UsersWithSuspense />} />
                </Route>
                <Route path="/unauthorized" element={<Unauthorized />} />
            </Route>

        </Routes>
    </>
}

export default App
